import { styled } from '@/styled-system/jsx';

export const StyledOrderedList = styled('ol', {
  base: {
    display: 'contents',
  },
});
